import { useEffect, useState } from "react";
import api from "../lib/api";
import { AuditList } from "./audit/AuditList";

export function JobHistory({ jobId }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get(`/audit?entity_id=${jobId}&limit=200`).then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0 }));
    }, [jobId]);
    return (
        <div className="bg-white border border-slate-200" data-testid="job-history">
            <div className="px-6 py-3 border-b-2 border-slate-900 flex items-center justify-between">
                <div className="font-display font-bold text-slate-900 text-sm uppercase tracking-wider">Historie změn zakázky</div>
                <div className="text-xs text-slate-500">{data ? `${data.total} záznamů · vč. faktur, rozpočtů, hodin a dohod k zakázce` : ""}</div>
            </div>
            <AuditList items={data?.items || []} loading={!data} />
        </div>
    );
}
